<template>
  <div>
    <b-tabs v-model="activeTab" justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">{{ $t("account.user-list") }}</span>
        </template>
        <management-account-list v-if="activeTab == 0" @accountDeleted="reloadWorkspaces()" />
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="far fa-user"></i>
          </span>
          <span class="d-none d-sm-inline-block">
            <span>{{ $t("workspace.plural") }} </span>
          </span>
        </template>
        <management-workspace-list v-if="activeTab == 1" />
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="far fa-user"></i>
          </span>
          <span class="d-none d-sm-inline-block">
            <span>{{ $t("organization.list") }} </span>
          </span>
        </template>
        <management-organization-list v-if="activeTab == 2" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ManagementWorkspaceList from "@modules/core/workspace/management-workspace-list";
import ManagementAccountList from "./management-account-list";
import managementOrganizationList from "./management-organization-list.vue";

export default {
  components: {
    ManagementAccountList,
    ManagementWorkspaceList,
    managementOrganizationList,
  },

  computed: {
    activeTab: {
      get() {
        return this.$store.getters[`accountWorkspaceOrganization/activeTab`];
      },
      set(index) {
        this.$store.commit(`accountWorkspaceOrganization/activeTab`, index);
      },
    },
  },
  methods: {
    reloadWorkspaces() {
      this.$store.dispatch("managementWorkspace/paginate");
    },
  },
};
</script>
